import logo from './logo.svg';
import './App.css';
import Mytodo from './Mytodo';
import Hero from './Hero';

function App() {
  return (
    <>
    <Hero/>
    <Mytodo/>
    </>
  );
}

export default App;
